module.exports = __webpack_public_path__ + "img/shanghai7.ab833507.png";